import React from "react";
import { NavLink } from "react-router-dom";

const TrendAnchor = ({ isProfile }) => (
  <NavLink to={{ pathname: "/trends", state: { isProfile } }}>
    <span>View all story trends</span>
  </NavLink>
);

export default TrendAnchor;
